<template>
  <div
    class="wrapper m-auto text-left one-company"
  >
    <GoBackButton />
    
    <CompanyControlCard :company="company" />
    <UserData :user="company" />

    <div
      id="offers"
      class="bg-card mt-2"
    >
      <strong>{{ $t('pages.admin.one-company.company-offers.title', 'Company offers') }}</strong>
      <span v-if="offers.length > 0"> ({{ offersMeta.total }})</span>
      <hr>
      <div v-if="offers.length > 0">
        <div
          v-for="offer in offers"
          :key="offer.id"
        >
          <OfferCard :offer="offer" />
        </div>
        <pagination
          v-if="offersMeta"
          :data="offersMeta"
          size="small"
          :limit="1"
          align="center"
          @pagination-change-page="getCompanyOffers"
        />
      </div>
      <div v-else>
        {{ $t('pages.admin.one-company.no-offers', 'No offers yet...') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import GoBackButton from '@/components/jobs/shared/GoBackButton';
import UserData from '@/components/jobs/CV/UserData';
import CompanyControlCard from '@/components/jobs/admin/CompanyControlCard';
import OfferCard from '@/components/jobs/admin/OfferCard';

export default {
  components: {
    GoBackButton,
    UserData,
    CompanyControlCard,
    OfferCard
  },
  data() {
    return {
      company: null,
      offers: null,
      offersMeta: null
    }
  },
  computed: {
    ...mapGetters('offers', {
      offerLoading: 'isLoading',
      offersList: 'list'
    }),

    ...mapState([
      'route', // vuex-router-sync
    ]),
  },
  mounted() {
    this.getCompany();
  },
  methods: {
    getCompany() {
      let userId = this.$route.params.id;
      this.axios.get('/users/' + userId)
        .then( response => {
          this.company = response.data;
          this.getCompanyOffers();
        })
        .catch();
    },
    getCompanyOffers(page = 1) {
      const config = {
        params: {
          page: page
        },
      };
      this.axios.get('/offer/company/' + this.company.company.id, config)
        .then(response => {
          this.offers = response.data.data;
          this.offersMeta = response.data;
        })
        .catch();
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 768px) {
    .one-company {
      width: 70%;
    }
  }
</style>
